import { render, staticRenderFns } from "./SdkAddReferensId.vue?vue&type=template&id=ec157354&"
import script from "./SdkAddReferensId.vue?vue&type=script&lang=js&"
export * from "./SdkAddReferensId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec157354')) {
      api.createRecord('ec157354', component.options)
    } else {
      api.reload('ec157354', component.options)
    }
    module.hot.accept("./SdkAddReferensId.vue?vue&type=template&id=ec157354&", function () {
      api.rerender('ec157354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkAddReferensId.vue"
export default component.exports